import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import SEOHelmet from '@/components/feature/SEOHelmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { categories, articles } from '@/mocks/comics';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!currentCategory) {
    return (
      <>
        <Navbar />
        <div className="pt-20 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-4">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 transition-colors">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SEOHelmet
        title={`${currentCategory.name} - 羞羞漫画分类浏览 | ${currentCategory.description}`}
        description={`羞羞漫画${currentCategory.name}分类，共收录${currentCategory.count}部精品漫画。${currentCategory.description}`}
        keywords={`${currentCategory.name},羞羞漫画,成人漫画,漫画分类,${currentCategory.name}漫画推荐`}
        canonicalUrl={`https://www.xiuxiumanhua.com/category/${slug}`}
        pageType="webpage"
      />
      <Navbar />

      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '分类浏览', path: '/category/romance' },
              { name: currentCategory.name },
            ]}
          />

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {currentCategory.name}
            </h1>
            <p className="text-sm text-foreground-500">{currentCategory.description}</p>
          </div>

          {/* Category Tabs */}
          <div className="flex flex-wrap items-center gap-2 mb-8 pb-6 border-b border-background-200">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50 font-medium'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Comic Grid */}
          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5 mb-10" data-product-shop>
              {categoryArticles.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                <i className="ri-file-search-line text-2xl text-foreground-400"></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-800 mb-2">暂无漫画</h3>
              <p className="text-sm text-foreground-500">该分类下暂无漫画作品，请浏览其他分类</p>
            </div>
          )}

          <div className="text-center pb-10">
            <p className="text-xs text-foreground-400">
              共 {categoryArticles.length} 部作品 &middot; {currentCategory.name}分类
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}